var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit-Blue"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.11499 19.75H6.53999L16.315 9.975L14.89 8.55L5.11499 18.325V19.75ZM3.11499 21.75V17.5L16.315 4.325C16.515 4.14167 16.7358 4 16.9775 3.9C17.2192 3.8 17.4733 3.75 17.74 3.75C18.0067 3.75 18.265 3.8 18.515 3.9C18.765 4 18.9817 4.15 19.165 4.35L20.54 5.75C20.74 5.93333 20.8858 6.15 20.9775 6.4C21.0692 6.65 21.115 6.9 21.115 7.15C21.115 7.41667 21.0692 7.67083 20.9775 7.9125C20.8858 8.15417 20.74 8.375 20.54 8.575L7.36499 21.75H3.11499ZM15.59 9.275L14.89 8.55L16.315 9.975L15.59 9.275Z",
    fill: "#2854C5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.51050bcdaf7be3263d812cc57e290798.svg";
export { ForwardRef as ReactComponent };